/**
 *   Generated file. Do not edit
 */

export const ResourceMetaData = {
  '/mqtt/client-id': {
    put: {
      minApiVersion: 1.86,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 32,
      },
    },
  },

  '/mqtt/username': {
    put: {
      minApiVersion: 1.86,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 32,
      },
    },
  },

  '/mqtt/broker-hostname': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 64,
      },
    },
  },

  '/mqtt/broker-port': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 32,
      },
    },
  },

  '/mqtt/password': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 32,
      },
    },
  },

  '/mqtt/relay-net-key': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 32,
      },
    },
  },

  '/mqtt/broker-certificate': {
    put: {
      minApiVersion: 1.86,
      configModeRequired: false,
      schema: {
        $ref: './definitions.yaml#/Bytes',
      },
    },
  },

  '/mqtt/topic-prefix': {
    put: {
      minApiVersion: 1.86,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 100,
      },
    },
  },

  '/mqtt/request-topic': {
    put: {
      minApiVersion: 1.86,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 100,
      },
    },
  },

  '/mqtt/response-topic': {
    put: {
      minApiVersion: 1.107,
      configModeRequired: false,
      schema: {
        type: 'string',
        maxLength: 100,
      },
    },
  },
};
